import React, { useEffect, useState } from 'react'
import styled from 'styled-components'

import { ColumnFlexCentered, Flex } from '~/components/common/containers'
import { H1, H4 } from '~/components/common/headers'
import { translate } from '~/core/translate'
import withNotifications from '~/components/with-notifications'
import analytics from '~/services/analytics'
import GotoAppButton from '../goto-app-button'
import appConfig from '../../app-config'
import { getCurrentPlan } from '../../services/api'
import { APP_REDIRECT_TIMEOUT } from '~/core/constants'
import JaasLogo from '~/components/icons/jaas-logo'

let handler

const Message = styled(H4)`
  margin-bottom: 32px;
`

const Container = styled(ColumnFlexCentered)`
  padding: 16px;
  margin: auto;
  text-align: center;

  ${H1} {
    margin: 24px auto 4px;
  }
`

const init = async () => {
  try {
    const res = await getCurrentPlan()

    analytics.trackPageView(analytics.PAGE_NAMES.PAYMENTS_SUCCESS_PAGE, {
      userType: analytics.USER_TYPE.VPAAS,
      planName: res[0].plan.name
    })
  } catch (err) {
    analytics.trackPageView(analytics.PAGE_NAMES.PAYMENTS_SUCCESS_PAGE, { userType: analytics.USER_TYPE.VPAAS })
  }
}

const SuccessPage = () => {
  const [buttonDisabled, setButtonDisabled] = useState(false)

  useEffect(() => {
    init()
    handler = setTimeout(() => {
      setButtonDisabled(true)
      appConfig.current.goToApp()
    }, APP_REDIRECT_TIMEOUT)
  }, [])

  const clearAutoredirect = () => {
    setButtonDisabled(true)
    handler && clearTimeout(handler)
  }

  return (
    <Flex fullWidth fullHeight>
      <Container fullWidth>
        <JaasLogo />

        <H1>{translate('congratulations')}</H1>

        <Message>{translate('success_register_vpaas')}</Message>

        <GotoAppButton onBeforeRedirect={clearAutoredirect} buttonDisabled={buttonDisabled} />

      </Container>
    </Flex>
  )
}

export default withNotifications(SuccessPage)
